import React from "react";
import { Fab, Tooltip } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsAppBadge = () => {
  const whatsappUrl = "https://wa.me/61449609681";

  return (
    <Tooltip title="Contact us on WhatsApp" placement="left" arrow>
      <Fab
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact us on WhatsApp"
        sx={{
          position: "fixed",
          bottom: { xs: 16, sm: 24 },
          right: { xs: 16, sm: 24 },
          backgroundColor: "#25D366",
          color: "#fff",
          zIndex: 1000,
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
          transition: "transform 0.3s ease, background-color 0.3s ease",
          "&:hover": {
            backgroundColor: "#20ba5a",
            transform: "scale(1.15)",
          },
          // Optional subtle continuous pulse effect
          animation: "whatsapp-pulse 2s infinite alternate",
          "@keyframes whatsapp-pulse": {
            "0%": {
              boxShadow: "0 0 0 0px rgba(37, 211, 102, 0.4)",
            },
            "100%": {
              boxShadow: "0 0 0 12px rgba(37, 211, 102, 0)",
            },
          },
        }}
      >
        <WhatsAppIcon sx={{ fontSize: 28 }} />
      </Fab>
    </Tooltip>
  );
};

export default WhatsAppBadge;
